import {
  CHART_TYPES,
  FORM_FILTERS_LIST,
  NOTIFICATION_ACCESS,
  NOTIFICATION_TEMP_MESSAGES,
  WHATSAPP_TEMPLATE_CHART_NAMES,
  WHATSAPP_TEMPLATE_CHART_PARAM
} from "./constants/NotificationTemplateConstants";
import { Component, Vue, Inject, Watch } from "vue-property-decorator";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import { Http } from "@status/codes";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import {
  ACCESS_OPTIONS_TRUE,
  GENERAL_CONSTANTS,
  LIST_COLLECTIONS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import SaveNotificationTemplate from "./components/SaveNotificationTemplate/SaveNotificationTemplate.vue";
import { SearchContext } from "@/shared/models/SearchContext";
import store from "@/store";
import { NotificationTemplateServices } from "./services/NotificationTemplateService";
import { NOTIFICATION_TEMP_CONSTANTS } from "./constants/NotificationTemplateConstants";
import { NotificationTemplateFilterResponse } from "./models/notification-template-filter-response.model";
import { NotificationTemplateFilter } from "./models/notification-template-filter.model";
import { ListOptions } from "./models/list-options.model";
import DocumentViewer from "@/shared/components/DocumentViewer/DocumentViewer.vue";
import { NavigationGuardNext, Route } from "vue-router";
import { Utils } from "@/shared/utils/utils";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import { AxiosError } from "axios";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import { CHART_INIT } from "@/shared/components/CrudChart/constants/CrudChartConstants";
import { TemplateQuery } from "./models/template-query.model";
import { CrudChartData } from "@/shared/models/CrudChartData";
import { ParameterConfig } from "./models/parameter-config.model";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "NotificationTemplate",
  components: {
    EmptyState,
    SaveNotificationTemplate,
    DocumentViewer,
    CrudChart
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class NotificationTemplate extends Vue {
  @Inject() notificationTemplateService!: NotificationTemplateServices;

  btnClassPrimaryRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  cardClass = STYLE_CLASSES.CARD;
  CATEGORY_LIST: ListOptions = new ListOptions();

  channelChartData = CHART_INIT;
  categoryChartData = CHART_INIT;
  typeChartData = CHART_INIT;

  CHANNEL_LIST: ListOptions = new ListOptions();
  CHART_TYPES = CHART_TYPES;

  EMPTY_STATE = FORM_MESSAGES.INFO_MESSAGE;
  currentNotificationTemplateId = "";

  dataToMainView!: MenuDataStructure;
  filterArray: Filter[] = FORM_FILTERS_LIST;
  viewerKey = 0;
  isEditing = true;
  isLoadingCharts = false;
  showCharts = false;
  isVisibleSaveTemplate = false;
  listOfTemplates = [];
  filters: NotificationTemplateFilter = { graphs: "true" };
  menu = false;
  primaryBtn = STYLE_CLASSES.PRIMARY_BTN;
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  SYNC_TEMP = NOTIFICATION_TEMP_CONSTANTS.SYNC_TEMP;
  TITLE_PAGE = NOTIFICATION_TEMP_CONSTANTS.PAGE_TITLE;
  TOOLTIP = NOTIFICATION_TEMP_CONSTANTS.TOOLTIP;
  TYPE_LIST: ListOptions = new ListOptions();

  DOCUMENT_NAME = "";
  DOCUMENT_LINK = "";
  documentDialog = false;
  parametersConfiguration: ParameterConfig[] | undefined = [];

  async mounted() {
    const data = await this.getFilteredData();

    if (data.templates?.length > 0) {
      this.setLists(data.lists);
      this.getParametersNotificationsConfig();
      this.buildSidePanelFilters();
    }
    this.emitSearchInitializer();
  }

  async getFilteredData(): Promise<NotificationTemplateFilterResponse> {
    try {
      this.isLoadingCharts = true;
      const response = await this.notificationTemplateService.filterTemplates(
        this.filters
      );

      if (response.code === Http.Found && response.data) {
        response.data.templates.forEach(
          item => (item.id = item.appId as string)
        );

        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
          response.data.templates
        );

        if (response.data.graphs) {
          this.updateGraphs(response.data.graphs);
          this.showCharts = true;
        } else {
          this.showCharts = false;
        }
        this.isLoadingCharts = false;
        return response.data;
      } else {
        if (response.code === Http.NotFound) {
          Snackbar.popInfo(NOTIFICATION_TEMP_MESSAGES.NO_TEMPLATES);
        } else {
          Snackbar.popError(response.message);
        }
        this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);

        this.showCharts = false;
        this.isLoadingCharts = false;
        return {} as NotificationTemplateFilterResponse;
      }
    } catch (error) {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + NOTIFICATION_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.isLoadingCharts = false;
      this.showCharts = false;
      return {} as NotificationTemplateFilterResponse;
    }
  }

  updateGraphs(graphs: CrudChartData) {
    this.channelChartData = {
      chartTitle: WHATSAPP_TEMPLATE_CHART_NAMES.CHANNEL,
      chartRenderData: Utils.mapChartData(
        graphs,
        WHATSAPP_TEMPLATE_CHART_PARAM.CHANNEL
      )
    };
    this.categoryChartData = {
      chartTitle: WHATSAPP_TEMPLATE_CHART_NAMES.CATEGORY,
      chartRenderData: Utils.mapChartData(
        graphs,
        WHATSAPP_TEMPLATE_CHART_PARAM.CATEGORY
      )
    };
    this.typeChartData = {
      chartTitle: WHATSAPP_TEMPLATE_CHART_NAMES.TYPE,
      chartRenderData: Utils.mapChartData(
        graphs,
        WHATSAPP_TEMPLATE_CHART_PARAM.TYPE
      )
    };
  }

  async syncTemplates() {
    try {
      const response = await this.notificationTemplateService.syncTemplates();

      if (response.code === Http.Ok) {
        const data = await this.getFilteredData();
        this.showCharts = true;
        this.setLists(data.lists);
        Snackbar.popSuccess(response.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + NOTIFICATION_ACCESS.POST
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  emitSearchInitializer() {
    const operationActive = { ...ACCESS_OPTIONS_TRUE, delete: false };
    const operations = Utils.addExtraOperations(
      [],
      COLLECTIONS_NAME.NOTIFICATION_TEMPLATE,
      operationActive
    );

    const searchContext: SearchContext = {
      title: NOTIFICATION_TEMP_CONSTANTS.PAGE_TITLE_SEARCH,
      filterArray: this.filterArray,
      operations: operations,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      componentName: COMPONENT_NAME_MODAL.NOTIFIVATION_TEMPLATE,
      descriptions: NOTIFICATION_TEMP_CONSTANTS.CARD_DESCRIPTIONS
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
  }

  async handleOperation(action: string, itemId: string) {
    this.viewerKey = 1 - this.viewerKey;
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.isVisibleSaveTemplate = true;
        this.currentNotificationTemplateId = itemId;
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
          itemId
        );
        break;

      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateNotificationTemplateById(itemId, STATE.ACTIVE);
        this.restoreView(false);
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateNotificationTemplateById(itemId, STATE.INACTIVE);
        this.restoreView(false);
        break;
      case LIST_DATA_EVENTS.VIEW_DATA:
        await this.openDocument(itemId);
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.restoreView(false);
        break;
    }
  }

  async updateStateNotificationTemplateById(id: string, state: string) {
    try {
      const responseData = await this.notificationTemplateService.updateStateNotificationTemplateById(
        id,
        state
      );
      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        this.searchTemplates({});
      } else {
        Snackbar.popError(NOTIFICATION_TEMP_MESSAGES.ERROR_UPDATING);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + NOTIFICATION_ACCESS.PUT
        );
      else Snackbar.popError(NOTIFICATION_TEMP_MESSAGES.ERROR_UPDATING);
    }
  }

  onCloseModal() {
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
  }

  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  @Watch("dataToMainView")
  panelValidation() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH &&
      this.dataToMainView.action ===
        PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE
    ) {
      this.searchTemplates(this.dataToMainView.data);
    } else if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.action ===
        PANEL_INFO_CONSTANTS.ACTION.DO_ON_BOTTOM_CONTEXT
    ) {
      this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.LOADED_CONTEXT);
    }
  }

  async searchTemplates(querySearch?: TemplateQuery) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.LOADING_CONTEXT_AND_HIDE_CARDS
    );
    if (querySearch && querySearch.state && querySearch.state.length == 1) {
      this.filters.state = querySearch.state[0];
    } else {
      delete this.filters.state;
    }
    if (querySearch && querySearch.channel) {
      this.filters.channel = querySearch.channel;
    } else {
      delete this.filters.channel;
    }
    if (querySearch && querySearch.category) {
      this.filters.category = querySearch.category;
    } else {
      delete this.filters.category;
    }
    if (querySearch && querySearch.type) {
      this.filters.type = querySearch.type;
    } else {
      delete this.filters.type;
    }
    if (querySearch && querySearch.name && querySearch.name.length == 1) {
      this.filters.name = querySearch.name[0];
    } else {
      delete this.filters.name;
    }
    await this.getFilteredData();
  }

  setLists(lists: Array<ListOptions>) {
    this.CHANNEL_LIST = lists[0];
    this.CATEGORY_LIST = lists[1];
    this.TYPE_LIST = lists[2];
  }

  buildSidePanelFilters() {
    this.filterArray.forEach(filter => {
      filter.secondaryFilters[1].options = this.CHANNEL_LIST.options.map(
        item => ({
          key: item,
          name: item
        })
      );
      filter.secondaryFilters[2].options = this.CATEGORY_LIST.options.map(
        item => ({
          key: item,
          name: item
        })
      );
      filter.secondaryFilters[3].options = this.TYPE_LIST.options.map(item => ({
        key: item,
        name: item
      }));
    });
  }

  async channelChartClick(label: string) {
    this.filters = {
      channel: [label],
      graphs: "true"
    };
    await this.getFilteredData();
  }

  async categoryChartClick(label: string) {
    this.filters = {
      category: [label],
      graphs: "true"
    };
    await this.getFilteredData();
  }

  async typeChartClick(label: string) {
    this.filters = {
      type: [label],
      graphs: "true"
    };
    await this.getFilteredData();
  }

  async chartClickOut() {
    this.filters = {
      graphs: "true"
    };
    await this.getFilteredData();
  }

  async openDocument(templateId: string) {
    try {
      const response = await this.notificationTemplateService.getTemplateById(
        templateId
      );

      if (response.code === Http.Found && response.data) {
        const data = response.data.data.split("|");
        if (data.length > 1) {
          const link = data[1]
            .trim()
            .slice(1, -1)
            .split(",");
          this.DOCUMENT_NAME = link[0];
          this.DOCUMENT_LINK = link[1];
          this.documentDialog = true;
        } else {
          Snackbar.popError(NOTIFICATION_TEMP_MESSAGES.NO_DOCUMENT_TEMPLATE);
        }
      } else {
        Snackbar.popError(NOTIFICATION_TEMP_MESSAGES.ERROR);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${NOTIFICATION_ACCESS.GET}`
          : NOTIFICATION_TEMP_MESSAGES.ERROR;

      Snackbar.popError(errorMessage);
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  async restoreView(search: boolean) {
    this.isVisibleSaveTemplate = false;
    this.currentNotificationTemplateId = "";
    if (search) {
      await this.searchTemplates();
    }
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
    );
  }

  async getParametersNotificationsConfig() {
    try {
      const response = await this.notificationTemplateService.getParametersConfig();
      this.parametersConfiguration = [];
      if (response.code === Http.Found) {
        if (response.data && response.data.length > 0) {
          this.parametersConfiguration = response.data.map(e => {
            return {
              ...e,
              type: "",
              visualName:
                e.collection == ""
                  ? NOTIFICATION_TEMP_CONSTANTS.TYPE_LABEL
                  : LIST_COLLECTIONS.find(item => item.key == e.collection)
                      ?.name,
              disabled: false,
              fields: e.fields?.map(field => {
                return {
                  ...field,
                  checked: false
                };
              })
            };
          });
        }
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + NOTIFICATION_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
}
